'use strict';
var emailRegex = require('email-regex');

module.exports = function (str) {
	return emailRegex({exact: true}).test(str);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/is-email-like/index.js
// module id = 176
// module chunks = 0